// src/validation/emailBlacklist.ts

export const blacklistedEmails = ['info@santa.lt'].map((email) =>
  email.toLowerCase(),
);

export const blacklistedEmailMessage =
  'Atsiprašome, bet šiuo el. paštu registracija negalima. Prašome nurodyti asmeninį el. pašto adresą.';

export const isBlacklistedEmail = (email) => {
  return blacklistedEmails.includes(email.trim().toLowerCase());
};
